<template>
  <section ref="scene" class="scene">
    <i v-show="loading" class="icon loading loading-pos"></i>
    <!-- MAIN MODEL USING vue-3d-model package -->

    <canvas v-show="!loading" id="rotModel" class="rotating-product"></canvas>
  </section>
</template>

<script>
import * as BABYLON from 'babylonjs';
import 'babylonjs-loaders';
import axios from 'axios';
import AssetsApiService from '@/services/assetsServices/assetsApiService';

const modelBackgroundColor = '#181818';
export default {
  props: {
    stop: {
      type: Boolean,
      required: true,
    },
    prefix: {
      type: String,
      required: true,
    },
    radioName: {
      type: String,
      required: true,
    },
    radio: {
      type: Object,
      required: true,
    },
    isStatic: {
      type: Boolean,
      default: true,
    },
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      buildNumber: 0
    };
  },
  watch: {
    stop: {
      handler() {
        //this.arcCamera.useFramingBehavior = true;
        this.moveCameraBack(
          this.arcCameraPos.alpha,
          this.arcCameraPos.beta,
          this.arcCameraPos.radius,
          5
        );
      }
    },
    radioName: {
      handler() {
        this.loading = true;
        /*this.arcCameraPos = {
          ...this.radio.rotatingProductSettings,
          radius: 1.5
        };*/
        this.init();
      },
    },
  },
  mounted() {
    axios
      .get(`${this.getStaticUrl()}assetsConfig.json?` + Date.now())
      .then((result) => {
        this.buildNumber = result.data.buildNumber;
        this.$nextTick(() => {
          this.init();
        });
    });
  },
  beforeMount() {
    /* Setting camera-angle to fit box (all of that is custom data) */
    this.arcCameraPos = { ...this.radio.rotatingProductSettings, radius: 1.5 };
    const dracoFolder = process.env.IS_ELECTRON
      ? 'static/draco'
      : `${this.$router.options.base}static/draco`;
    BABYLON.DracoCompression.Configuration = {
      decoder: {
        wasmUrl: `${dracoFolder}/draco_wasm_wrapper_gltf.js`,
        wasmBinaryUrl: `${dracoFolder}/draco_decoder_gltf.wasm`,
        fallbackUrl: `${dracoFolder}/draco_decoder_gltf.js`
      }
    };
  },
  beforeDestroy() {
    this.scene.dispose();
    this.engine.dispose();

    window.removeEventListener('resize', this.resizer);
  },

  methods: {
    startLoading() {
      this.loading = true;
    },
    moveCameraBack(toAlpha, toBeta, toRadius, animationFrames) {
      var animCamAlpha = new BABYLON.Animation(
        'animCam',
        'alpha',
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      );

      var keysAlpha = [];
      keysAlpha.push({
        frame: 0,
        value: this.arcCamera.alpha
      });
      keysAlpha.push({
        frame: animationFrames,
        value: toAlpha
      });
      var animCamBeta = new BABYLON.Animation(
        'animCam',
        'beta',
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      );

      var keysBeta = [];
      keysBeta.push({
        frame: 0,
        value: this.arcCamera.beta
      });
      keysBeta.push({
        frame: animationFrames,
        value: toBeta
      });
      var animCamRadius = new BABYLON.Animation(
        'animCam',
        'radius',
        30,
        BABYLON.Animation.ANIMATIONTYPE_FLOAT,
        BABYLON.Animation.ANIMATIONLOOPMODE_CYCLE
      );

      var keysRadius = [];
      keysRadius.push({
        frame: 0,
        value: this.arcCamera.radius
      });
      keysRadius.push({
        frame: animationFrames,
        value: toRadius
      });
      animCamAlpha.setKeys(keysAlpha);
      animCamBeta.setKeys(keysBeta);
      animCamRadius.setKeys(keysRadius);
      this.arcCamera.animations.push(animCamAlpha);
      this.arcCamera.animations.push(animCamBeta);
      this.arcCamera.animations.push(animCamRadius);
      this.scene.beginAnimation(
        this.arcCamera,
        0,
        animationFrames,
        false,
        1,
        function() {}
      );
    },
    setMainCamera() {
      // Add a camera to the scene and attach it to the canvas
      this.arcCamera = new BABYLON.ArcRotateCamera(
        'Camera',
        this.arcCameraPos.alpha,
        this.arcCameraPos.beta,
        this.arcCameraPos.radius,
        BABYLON.Vector3.Zero(),
        this.scene
      );
      /* Limiting camera angles */
      this.arcCamera.minZ = 0;
      this.arcCamera.lowerRadiusLimit = 0;
      this.arcCamera.speed = 0.084;
      this.arcCamera.pinchDeltaPercentage = 0.01;
      this.arcCamera.wheelDeltaPercentage = 0.01;
      this.arcCamera.lowerBetaLimit = 0.01;
      this.arcCamera.upperBetaLimit = 3.132;
      this.arcCamera.useAutoRotationBehavior = true;
      this.arcCamera.upperRadiusLimit = 300;

      /*
      this.arcCamera.useFramingBehavior = true;
 */
      this.arcCamera.attachControl(this.canvas, true);
    },
    createScene() {
      // tell Babylon.js to use decomposeLerp and matrix interpolation
      BABYLON.Animation.AllowMatricesInterpolation = true;

      this.scene = new BABYLON.Scene(this.engine);
      this.scene.clearColor = BABYLON.Color3.FromHexString(
        modelBackgroundColor
      );

      const hemi1 = new BABYLON.HemisphericLight(
        'HemisphericLightFront',
        new BABYLON.Vector3(0, 0, 1),
        this.scene
      );
      hemi1.intensity = 0.4;
      const hemi2 = new BABYLON.HemisphericLight(
        'HemisphericLightBack',
        new BABYLON.Vector3(0, 0, -1),
        this.scene
      );
      hemi2.intensity = 0.4;

      // var light = new BABYLON.DirectionalLight(
      //   "DirectionalLight",
      //   new BABYLON.Vector3(0, -1, 0),
      //   this.scene
      // );
      // light.intensity = 0.9;

      // var light1 = new BABYLON.DirectionalLight(
      //   "DirectionalLight2",
      //   new BABYLON.Vector3(-4, 1, -1),
      //   this.scene
      // );
      // light1.intensity = 1.5;

      // var light2 = new BABYLON.DirectionalLight(
      //   "DirectionalLight3",
      //   new BABYLON.Vector3(4, 1, -1),
      //   this.scene
      // );
      // light2.intensity = 1.5;

      // var light3 = new BABYLON.DirectionalLight(
      //   "DirectionalLight4",
      //   new BABYLON.Vector3(0, -1, -10),
      //   this.scene
      // );
      // light3.intensity = 1.5;

      const staticUrl = this.getStaticUrl();

      var hdrTexture = new BABYLON.CubeTexture.CreateFromPrefilteredData(
        `${staticUrl}Studio_Softbox_2Umbrellas_cube_specular.env`,
        this.scene
      );
      this.scene.environmentTexture = hdrTexture;
      // var helper = this.scene.createDefaultEnvironment({
      //   createSkybox: false,
      // });
      // helper.setMainColor(BABYLON.Color3.FromHexString("#0c0c0c"));
      this.setMainCamera();
      // helper.ground.dispose();
    },

    getStaticUrl() {
      if(this.radio.hasOwnProperty('parentId')) {
        return this.$route.name.split('/')[0] === 'custom-selection'
          ? '../../../../static/'
          : '../../static/';
      }

      return this.$route.name.split('/')[0] === 'custom-selection'
        ? '../../../static/'
        : '../../static/';
    },

    async init() {
      BABYLON.Database.IDBStorageEnabled = true;
      this.canvas = document.getElementById('rotModel');

      //@param1 = the canvas; @param2 = antialiasing; @param3 = EngineOptions, @param4 ? adaptToDeviceRatio: boolean = false
      this.engine = new BABYLON.Engine(this.canvas, true, {
        preserveDrawingBuffer: true,
        stencil: false,
      });

      if(this.isPreview) {
        this.engine.setHardwareScalingLevel(0.3)
      }
      

      this.createScene();
      const staticUrl = this.getStaticUrl();

      if (this.isStatic && !this.isPreview) {
        /* Importing 3d-model */
        BABYLON.SceneLoader.ImportMesh(
          '',
          staticUrl,
          `3D_draco/${this.radioName}` + '?' + this.buildNumber,
          this.scene,
          this.afterModelLoad, //callback
          () => {},
          (error) => {
            console.error('Error_loading_model', error);
          }
        );
      } else {
        const asset = await AssetsApiService.getModelAsset(this.radioName);
        const url = URL.createObjectURL(asset);

        BABYLON.SceneLoader.ImportMesh(
          '',
          url,
          '',
          this.scene,
          this.afterModelLoad, //callback
          () => {},
          (error) => {
            console.error('Error_loading_model', error);
          },
          '.glb'
        );
      }
    },
    renderScene() {
      this.scene.render();
    },
    afterModelLoad(meshes) {
      this.root = meshes[0];
      this.arcCamera.target = meshes[0];

      let model = meshes[0];

      let vectors = model.getHierarchyBoundingVectors();

      let size = {
        x: vectors.max.x - vectors.min.x,
        y: vectors.max.y - vectors.min.y,
        z: vectors.max.z - vectors.min.z
      };

      let radius = (
        Math.sqrt(size.x * size.x + size.y * size.y + size.z * size.z) * 1.5
      ).toFixed(3);

      this.arcCameraPos.radius = radius;
      this.arcCamera.radius = radius;

      /* Deactivate loading-symbol */
      this.loading = false;

      /* Start the the scene loop! */
      this.engine.runRenderLoop(this.renderScene);

      window.addEventListener('resize', this.resizer);
    },
    resizer() {
      this.loading = false;
      this.$nextTick(() => {
        this.engine.resize();
      });
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@eds/vanilla/variables/global.less';
/* Canvas */
#rotModel {
  height: 100%;
  width: 100%;
  outline: none;
  touch-action: none;
}
/* Loading */
.loading-pos {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

/* Main scene! */
.scene {
  position: relative;
  /* margin-left: 100px; */
  background-color: @gray-09;
  height: 100%;
  z-index: 0;
  transition: all 0.5s ease;
}
/* Transitions */
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  display: hidden;
}
</style>
